import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import WcIcon from '@mui/icons-material/Wc';
import ToggleButton from '@mui/material/ToggleButton';
import Switch from '@mui/material/Switch'
import Zoom from '@mui/material/Zoom';
import Fade from '@mui/material/Fade';

import AgeInfoDrawer from "../info_components/AgeInfo"



function createArray(n, m) {
  const result = [];
  for (let i = n; i <= m; i++) {
    result.push(i);
  }
  return result;
}

const testData = createArray(20, 64);
const range = [Math.min(...testData), Math.max(...testData)];
// const range = [20,60]

const marks = [
  {
    value: range[0],
    label: range[0],
  },
  {
    value: range[1],
    label: range[1],
  },
];




function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const CustomAgeSlider = styled(Slider)(({ theme, activegender }) => ({
  height: 8,
  padding: '20px 0',
  '&.MuiSlider-root': {
      pointerEvents: 'none !important',  // Disable clicks on the rail
    },
  '& .MuiSlider-thumb': {
    height: 28,
    width: 28,
    // boxShadow: '0 2px 1px rgba(0,0,0,0.1),0 4px 10px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)',
        backgroundColor: "white",
    border: "2.5px solid #1976d2", // MUI primary blue
    pointerEvents: 'all !important'
    // backgroundColor: '#212121',
    // '&:hover': {
    //   boxShadow: '0 0 0 10px rgba(58, 133, 137, 0.16)',
    // },
    // '&:before': {
    //   boxShadow:
    //     '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
    // },
  },
  // '& .MuiSlider-thumb[data-index="0"]': {
  //   backgroundImage: "radial-gradient(circle, #000000 40%, #abebff)"
  // },
  // '& .MuiSlider-thumb[data-index="1"]': {
  //   backgroundImage: "radial-gradient(circle, #000000 40%, #abebff)"
  // },
  '& .MuiSlider-valueLabel': {
    fontSize: 16,
    fontWeight: 'normal',
    top: -5,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    // '&::before': {
    //   display: 'none',
    // },
    // '& *': {
    //   background: 'transparent',
    //   color: '#000',
    //   ...theme.applyStyles('dark', {
    //     color: '#fff',
    //   }),
    // },
  },
  '& .MuiSlider-markLabel[data-index="0"]': {
    top: "15px",
    margin: "0 -20px",
    fontSize: 12
  },
  '& .MuiSlider-markLabel[data-index="1"]': {
    top: "15px",
    margin: "0 0 0 20px",
    fontSize: 12
  },
  '& .MuiSlider-track': {
    border: 'none',
    // backgroundColor: '#1976D1',
    backgroundImage: "linear-gradient(.25turn, #8ED4FF, #008FF5)",
    height: 10,
  },
  '& .MuiSlider-rail': {
    // opacity: 0.5,
    boxShadow: 'inset 0px 0px 4px -2px #000',
    backgroundColor: '#29292D',
    height: 10,
  },
  '& .MuiTabPanel-root': {
    padding: 0,
  },
  // ...theme.applyStyles('dark', {
  //   color: '#0a84ff',
  // }),
}));

export default function Age({ ageRange, onSlide, activeGender, agePercent }) {
  const value = ageRange.slice()
  // const [value, setValue] = React.useState(ageRange);
  const minDistance = 3;
  const [valueChange, setValueChange] = useState(false);


  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  const isIOS = iOS();

  const handleChange = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }
    if (isIOS && event.type === "mousedown") {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 100 - minDistance);
        onSlide([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        onSlide([clamped - minDistance, clamped]);
      }
    } else {
      onSlide(newValue);
    setValueChange(true)

    }
  };

  const [selectedInfo, setSelectedInfo] = useState(false);
  const [selectedHelp, setSelectedHelp] = useState(false);

  const [ageTip, setAgeTip] = useState(false);
  useEffect(() => {
    if(valueChange) {
    setTimeout(() => {
      setAgeTip(true)
  }, 2500);
}
  
}, [valueChange]);


const [formQuestion, setFormQuestion] = useState(1)

    const nextQuestionHandler = (e) => {
        // e.preventDefault()
        console.log(e.target)
        const nextQuestion = parseInt(e.target.value)
            setFormQuestion(nextQuestion)
    }

// const handleChange = (e) => {
//   const name = e.target.name;
//   const value = e.target.value;
//   setInputs(values => ({ ...values, [name]: value }))
// }




  return (
    <div className="wrapperScroll">

      <div className="wrapperWidth">

        <div className="sliderContainerParent">
<Fade
                        // in={false ? true : false}
                        in={selectedHelp ? true : false}
                        timeout={500}
                    >
                        <div className="helpContainer" onClick={() => { setSelectedHelp(!selectedHelp) }}>
                            <div className="helpBox">
                                <h2 className="helpText">Tips</h2>
                                <p className="helpText">- 🤖 The percentage in the Age tab above updates as you adjust your range, showing what share of the population it captures.</p>
                                <p className="helpText">- 🚻💍 The Orientation tab percentage also updates since age correlates with gender identity and marital status—for example, younger age ranges include more people who’ve never been married.</p>
                            </div>
                        </div>
                    </Fade>
                    <AgeInfoDrawer selectedInfo={selectedInfo} setSelectedInfo={setSelectedInfo} />
          <div className="componentHeaderContainer">
            <div className="componentHeader">
              <div className="descriptionContainer">
                <p className="description">Desired age range</p>
              </div>
              <div className="info">
                <ToggleButton
                  value={1}
                  selected={selectedInfo}
                  onChange={() => setSelectedInfo((prevSelected) => !prevSelected)}
                  sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgb(45 185 255 / 17%)" } }}
                >
                  <InfoIcon />
                </ToggleButton>
                <ToggleButton
                  value={1}
                  selected={selectedHelp}
                  onChange={() => {setSelectedHelp((prevSelected) => !prevSelected); setSelectedInfo(false)}}
                  sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                >
                  <HelpIcon />
                </ToggleButton>
              </div>
            </div>
            {/* <p className="note">(Min and max values represent bottom and top 5th percentiles)</p> */}
          </div>
          <div style={{height: 10}}></div>
          <div className="ageContainer">
            <Box sx={{ width: "100%", margin: "12px 0 0 0", padding: "12px 0 0 0" }}>
              <CustomAgeSlider
                // aria-label="ios slider"
                // getAriaLabel={() => 'Age range'}
                value={value}
                min={range[0]}
                max={range[1]}
                // marks={marks}
                onChange={handleChange}
                valueLabelDisplay="on"
                disableSwap
                activegender={activeGender}
              />
            </Box>
          </div>
          <div>
            <p className="sourceSlim">Source: U.S. Census Bureau, 2023 American Community Survey (NYC - S0101)</p>
          </div>
        </div>
      </div>





      <div className="catContainerCriteria">
        <div className="img-wrapper"
          style={ageTip ? { display: "block", animationName: "upCat" } : { display: "none" }}
        >
                {/* <div id="calico" className="bye-container"> */}
          {/* <div className="questionContainer"> */}
          <Fade
      in={ageTip}
      {...(ageTip ? { timeout: 2000 } : {})}
      >
        {/* <> */}
            <div id="calico" className="question-bubble" 
            >
              <div style={{width: "100%"}}>
              <p className="center"> Your <span className="highlight">selected age range</span> captures</p>
              <p className="center"> <span className="highlight">{agePercent}%</span> of the population!</p>
              <p className="center">You can also see this percentage in the navigation bar above.</p>
              </div>

          </div>
          {/* <div id="calico" className="question-bubble"
            hidden={formQuestion !== 2} 
            >
              <p>Psst! Wondering what the percents under each criteria mean?<span className="highlight"></span></p>

          </div> */}
          {/* </> */}
          </Fade>

          <img src={"../images/orange.png"} className="catImgCriteria"></img>

        </div>
      </div>




    </div>
  );
}
